import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Activity, Menu, X } from "lucide-react";

const NAV = [
  { label: "Edge", href: "#manifesto" },
  { label: "Track Record", href: "#track" },
  { label: "Whale Radar", href: "#whales" },
  { label: "Access", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Header = ({ onJoin }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="header-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "glass border-b border-[#14f19522]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <span className="font-display font-black text-xl tracking-tight text-white">
            500<span className="text-[#14F195] text-glow-green">X</span>
          </span>
          <span className="hidden sm:inline text-[10px] font-mono uppercase tracking-[0.25em] text-[#64748B]">
            insider
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="text-sm font-medium text-[#94A3B8] hover:text-white transition-colors duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            data-testid="live-status-badge"
            className="hidden lg:flex items-center gap-2 rounded-full border border-[#14f19533] bg-[#14f1950f] px-3 py-1.5"
          >
            <Activity className="w-3.5 h-3.5 text-[#14F195] animate-pulse" />
            <span className="font-mono text-[10px] uppercase tracking-wider text-[#14F195]">
              MEV Bot · Online
            </span>
          </div>
          <button
            data-testid="header-join-button"
            onClick={onJoin}
            className="hidden sm:inline-flex items-center rounded-full bg-[#14F195] px-4 py-2 text-sm font-bold text-[#05060A] hover:bg-[#3dffb0] hover:scale-[1.03] active:scale-95 transition-transform duration-200"
          >
            Join VIP · 2 SOL
          </button>
          <button
            className="md:hidden text-white p-1"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden glass border-t border-[#14f19522]"
          >
            <div className="px-5 py-4 flex flex-col gap-3">
              {NAV.map((n) => (
                <a
                  key={n.label}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-[#94A3B8] hover:text-white transition-colors py-1"
                >
                  {n.label}
                </a>
              ))}
              <button
                onClick={() => {
                  setOpen(false);
                  onJoin();
                }}
                className="mt-2 rounded-full bg-[#14F195] px-4 py-2.5 text-sm font-bold text-[#05060A]"
              >
                Join VIP · 2 SOL
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
